var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("article", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "<li data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" >\n        <a class=\"PerspectiveArticlesListInner-article\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"url"), env.opts.autoescape);
output += "\">\n            <div class=\"PerspectiveArticlesListInner-articleImg\">\n                ";
if(runtime.memberLookup((t_7),"cover")) {
output += "<img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"cover")),"w440_url"), env.opts.autoescape);
output += "\"\n                  srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"cover")),"w680_url"), env.opts.autoescape);
output += " 2x\"\n                  alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"title"), env.opts.autoescape);
output += "\">\n                ";
;
}
output += "</div>\n            <div class=\"PerspectiveArticlesListInner-articleInfo\">\n                <div class=\"PerspectiveArticlesListInner-articleTitle\">";
output += runtime.suppressValue(runtime.memberLookup((t_7),"title"), env.opts.autoescape);
output += "</div>\n                <div class=\"PerspectiveArticlesListInner-articleDetails\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_7),"shortText")), env.opts.autoescape);
output += "</div>\n            </div>\n            <div class=\"PerspectiveArticlesListInner-articleArrow\">\n                ";
output += runtime.suppressValue((lineno = 18, colno = 38, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
output += "\n            </div>\n        </a>\n    </li>\n";
;
}
}
frame = frame.pop();
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.jinja
// module id = 126
// module chunks = 0